import { render, staticRenderFns } from "./ContentList.vue?vue&type=template&id=c5611dc0&"
import script from "./ContentList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ContentList.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5611dc0')) {
      api.createRecord('c5611dc0', component.options)
    } else {
      api.reload('c5611dc0', component.options)
    }
    module.hot.accept("./ContentList.vue?vue&type=template&id=c5611dc0&", function () {
      api.rerender('c5611dc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPageLpuList/components/DoctorAppointmentCard/components/WorkplaceOrServiceDialog/components/ContentList.vue"
export default component.exports